import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'
import NormalPlay from "@/components/NormalPlay.vue";
import AdminLive from "@/components/AdminLive.vue";
import OperaterLive from "@/components/OperaterLive.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: NormalPlay,
    //     meta: {
    //         keepAlive: true,
    //     }
    // },

    // {
    //     path: '/',
    //     name: 'Home',
    //     component: AdminLive,
    //     meta: {
    //         keepAlive: true,
    //     }
    // },

    // {
    //     path: '/',
    //     name: 'Home',
    //     component: OperaterLive,
    //     meta: {
    //         keepAlive: true,
    //     }
    // },

    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: true,
        }
    },
    {
        path: '/normal_play',
        name: 'NormalPlay',
        component: NormalPlay
    },
    {
        path: '/admin_live',
        name: 'AdminLive',
        component: AdminLive
    },
    {
        path: '/opera_live',
        name: 'OperaterLive',
        component: OperaterLive
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
